import { createElement } from "react";
/**
 * Internal Dependencies
 */
import Coupon from './coupon';
import Info from './info';
import Methods from './methods';
const PaymentModal = ({
  data
}) => {
  return createElement("div", {
    className: "renderer-core-payment-modal"
  }, createElement("div", {
    className: "renderer-core-payment-modal__content"
  }, createElement(Info, {
    data: data
  }), createElement(Coupon, {
    data: data
  }), Object.keys(data.payments.methods).length > 0 ? createElement(Methods, {
    data: data
  }) : createElement("div", null, "No available payment methods. Please contact the administrator.")));
};
export default PaymentModal;
//# sourceMappingURL=index.js.map